import React from "react";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import Toggle from "react-toggle";
import { secondaryBackButton } from "utils/constants/ui";
import MenuNavHeader from "components/MenuNavHeader";
import { getToggleProps } from "utils/form";

const ProductPresentationSettings = () => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const goBack = () => {
    setFieldValue(STATE_KEYS.EDITOR.PRICING_INTENT, null);
    setFieldValue(STATE_KEYS.EDITOR.PRICING_ACTIVE_PRICE, null);
  };

  const buttonProps = secondaryBackButton({ onClick: () => goBack() });

  const showImagery = get(values, STATE_KEYS.MANIFEST.PRICING_SHOW_IMAGERY);

  return (
    <div className="w-100">
      <MenuNavHeader navSetters={[buttonProps]} label="Product presentation" />
      <div className="pt3 bh--inset">
        <div className="f4 ph3 pb3 fw5">Imagery</div>
        <div className="f6 lh-copy ph3 pb3">
          Show imagery for each product on the pricing table, if available.
        </div>
        <div className="ph3">
          <Toggle
            {...getToggleProps({
              active: showImagery,
              setFieldValue: (_, active) => {
                setFieldValue(STATE_KEYS.MANIFEST.PRICING_SHOW_IMAGERY, active);
                setFieldTouched(STATE_KEYS.MANIFEST.PRICING_SHOW_IMAGERY, true);
              }
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductPresentationSettings;
